<script lang="ts">
    import Product from "../../Models/Product";
    import { setLatestEditedProduct } from "../../Stores/Product";

    export let _id: string;
    export let field: { name: string, value: string };

    const type = isNaN(+field.value) ? 'text' : 'number';
    const width = type == 'text' ? '200px' : '50px';

    let editMode = false;
    let editProductInputElement: HTMLInputElement;
    let metric;

    switch(field.name) {
        case 'price':
            metric = 'zł';
            break;
        case 'discount':
            metric = '%';
            break;
        default:
            metric = '';
    }

    function toggleEditMode() {
        editMode = true;
    }

    async function sendEditProductRequest(e) {
        if (e.key === 'Enter' || !e.key) {
            const res = await Product.update(_id, field);
            setLatestEditedProduct(_id);
            editMode = false;
        }
    }

    async function sendRemoveProductRequest(e) {
        const res = await Product.remove(_id);
        setLatestEditedProduct(_id);
    }
</script>

<div class="editProductInput">
    {#if !editMode}
        <span on:click={toggleEditMode}>{field.value}</span>
        {#if field.name == 'name'}
            <img on:click={sendRemoveProductRequest} class="icon" src="/assets/icons/delete.png" alt="Usuń">
        {/if}
    {:else}
        <div class="editGroup">
            <input on:keydown={sendEditProductRequest} bind:this={editProductInputElement} bind:value={field.value} style="width: {width}">
            <img on:click={sendEditProductRequest} class="acceptButton" src="/assets/icons/check.png" alt="">
        </div>
    {/if}
    <span on:click={toggleEditMode}>{metric}</span>
</div>

<style lang="scss">
    .editProductInput {
        .editGroup {
            input {
                margin: 0;
                height: 20px;
                width: fit-content;
                outline: none;
            }

            .acceptButton {
                width: 12px;
                transform: translateX(-20px);
                cursor: pointer;
            }
        }

        .icon {
            width: 16px;
            cursor: pointer;
        }
    }
</style>